import type {ProCoverageItem} from '../../../../../types';

import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Slider} from '@ds/components';
import {cn} from '@ds/helpers';

import {
  PRO_DELIVERY_METHOD_LABELS,
  PRO_ZONE_DOT_CLASS,
  PRO_ZONE_SLIDER_CLASS
} from '../../../../../constants';

type ProEditableZoneProps = {
  item: ProCoverageItem;
  selectedCount: number;
  onCountChange: (count: number) => void;
};

const ProEditableZone: React.FC<ProEditableZoneProps> = ({item, selectedCount, onCountChange}) => {
  const totalZones = item.polygons.length;

  return (
    <section className="mt-6">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="m-0 flex items-center gap-2 text-subtitle-md text-neutral-fg">
          <span
            className={cn('inline-block size-2.5 shrink-0 rounded-full', PRO_ZONE_DOT_CLASS[item.type])}
            aria-hidden
          />
          {PRO_DELIVERY_METHOD_LABELS[item.type]}
        </h3>
        <span className="shrink-0 text-body-xs text-gray-34">
          {selectedCount === 0 ? 'انتخاب نشده' : `${selectedCount} از ${totalZones} تا محدوده`}
        </span>
      </div>
      <div className="mt-1">
        <div className="flex items-center gap-3">
          <span className="shrink-0 text-body-xs text-gray-29">0</span>
          <Slider
            className={cn('min-w-0 flex-1', PRO_ZONE_SLIDER_CLASS[item.type])}
            min={0}
            max={totalZones}
            step={1}
            value={selectedCount}
            onChange={onCountChange}
            ariaLabel={`انتخاب تا محدوده ${selectedCount} از ${totalZones}`}
            formatAriaValue={(value) => `${value} از ${totalZones}`}
          />
          <span className="shrink-0 text-body-xs text-gray-29">{totalZones}</span>
        </div>
        <div className="mt-4 flex items-center justify-center gap-4">
          <button
            type="button"
            className="flex size-11 items-center justify-center rounded-lg border border-gray-22 bg-white text-neutral-fg disabled:cursor-not-allowed disabled:opacity-40"
            disabled={selectedCount <= 0}
            onClick={() => onCountChange(selectedCount - 1)}
            aria-label="کاهش محدوده"
          >
            <MinusOutlined aria-hidden />
          </button>
          <span className="min-w-18 text-center text-body-sm-emphasis text-neutral-fg">
            {selectedCount} / {totalZones}
          </span>
          <button
            type="button"
            className="flex size-11 items-center justify-center rounded-lg border border-gray-22 bg-white text-neutral-fg disabled:cursor-not-allowed disabled:opacity-40"
            disabled={selectedCount >= totalZones}
            onClick={() => onCountChange(selectedCount + 1)}
            aria-label="افزایش محدوده"
          >
            <PlusOutlined aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProEditableZone;
